<template>
  <div class="container">
    <h1>Bio</h1>
    <div id="bio">
      <span>I'M A FRENCH FASHION DESIGNER BORN AND RAISED IN PARIS WITH CARRIBEAN DESCENT.</span>
      <span>SELF-TAUGHT, I CERTAINLY INTRINSINCALLY TURNED TO FASHION FOR AESTHETIC REASONS.</span>
      <span>I TRULY SEE BEAUTY IN EVERY WOMEN.</span>
      <span>FASHION FOR ME IS UNMISTAKABLY SOME SORT OF THERAPY,</span>
      <span>A TOOL TO ASSERT ONE'S PERSONALITY AND SEDUCE OTHERS WHILE EXPRESSING YOURSELF. BEST IF IT IS THE REFLECTION OF YOUR TRUE SELF...</span>
      <span>IN MY COLLECTIONS, I TRY TO DEFINE FEMINITY AT LARGE.</span>
      <span>I MAY HAVE A FOCUS THOUGH ON THE FEMME FATAL I.E THE GLAMOUROUS AND SEXY WOMAN, HER DIFFERENT MOODS, DESIRES AND NEEDS.</span>
      <span>MY SIGNATURE COWL-NECK SWEATERS, A-LINE COATS, HOODED GOWNS AND THREE DIMENSIONAL CONCEPTS EXPOSE MY DEEPEST THOUGHTS. I CREATE WHAT I FEEL.</span>
      <span>I DON'T DRAW ANY OF MY DESIGNS, THEY ARE FRUITS OF VISUALIZATIONS OR TAKE SHAPE IN THE MAKING.</span>
      <span>ANYHOW, ALTHOUGH I DON'T FOLLOW TRENDS, EVERYTHING SEEMS TO INSPIRE ME:</span>
      <span>" FABRICS, VISUAL ART, NATURE, ARCHITECTURE, POP CULTURE OR WOMEN IN STREETS DICTATE MOST OF WHAT I DO - MY KEEN EYE IS THE STARTING POINT TO EVERYTHING "</span>
      <span>MY FASHION IS POETRY IN MOTION, BLENDING FEMININE, EDGY CONCEPTS INTO ROMANTIC AND WEARABLE ART. I LIKE TO DRESS WOMEN NOT DRESS THEM UP!</span>
      <span>IT'S ALSO IMPORTANT TO ME TO SHOW THAT MULTIPLICITY IS A RICHNESS, I'M A DIVERSITY AND INCLUSION ADVOCATE TO THE CORE OF MY BEING. I CARRY SO MANY CULTURES WITHIN ME OR LIKE I LIKE TO SAY, THE WORLD LIVES IN ME!</span>
      <span>SO... MY VISION IS ECLECTIC, PLURAL AND TOLERANT.  SO IS MY FASHION I GUESS.</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Bio',
  components: {
  },
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: `Kate Mack Bio`,
    // all titles will be injected into this template
    titleTemplate: null,
    description: 'Kate Mack - Bio',
    meta: [
      { charset: 'utf-8' },
      { 
        name: 'keywords',
        content: 'kate-mack, Kate, Mack, kate mack, Wearable Art Dealer, art, fashion, Local Designer, Small business, Designer, Artisan, Artisan Designer'
      },
      {
        property: 'og:title',
        content: 'Kate Mack',
        // following template options are identical
        // template: '%s - My page',
        template: chunk => `${chunk} - Bio`,
        vmid: 'og:title'
      },
      {
        property: 'og:url',
        content: `https://kate-mack.com/bio`,
        vmid: 'og:url'
      }
    ]
  },
}
</script>
<style lang="scss" scoped>
div.container {
  
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
h1 {
  color: #f5f5F5;
}
#bio {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 90%;
  span {
    color: #dcdcdc;
    margin: 0.3rem;
    text-align: left;
  }
  padding-bottom: 1rem;
}
@media screen and (min-width: 600px) {
  #bio {
    width: 70%;
  }
  
}
</style>